export default {
    lang: 'en',
    header: {
        official_website: 'Official website',
        user_enter: 'User Center',
        sign_out: 'Sign out',
        language: 'English',
    },
    aside: {
        dash_board: 'Dash board',
        knowledge_base: 'Knowledge Base',
        my_order: 'My Order',
        purchase_subscription: 'Purchase',
        node_status: 'Node Status',
        subscribe: 'purchase',
        finance: 'finance',
        user: 'user',
        order_details: 'Order details'
    },
    orders: {
        order_number: '# order number',
        cycle: 'Cycle',
        order_amount: 'order amount',
        order_status: 'order Status',
        to_be_paid: 'To be paid',
        cancelled: 'User cancels',
        timeOut: "Automatically cancel after timeout",
        fail: 'Payment failed',
        completed: 'Payment successful',
        creation_time: 'creation time',
        operate: 'operate',
        check_the_details: 'Check the details',
        cancel: 'Cancel',
        cancel_message: 'If you have already made the payment, canceling the order may result in payment failure. Are you sure you want to cancel the order?',
        Attention: 'Attention',
        sure: 'Determine',
        refunded:'Refunded',
        processing:'Processing',
        chargeback:'Chargeback',
        unknown:'Unknown',
        cancel_payment:'Cancel payment',
    },
    personal: {
        change_password: 'change Password',
        old_password: 'Old Password',
        please_enter_old_password: 'Please enter old password',
        new_password: 'New Password',
        please_enter_a_new_password: 'Please enter a new password',
        save: 'save',
        reset_subscription_information: 'Reset purchase information',
        reset_message: 'When your purchase address or account is leaked and abused by others, you can reset your purchase information here. Avoid unnecessary losses.',
        reset: 'Reset',
        change_subscription_info: 'If your purchase address or information is compromised, you can perform this operation. After resetting, your UUID and purchase will change and you need to import your purchase again.',
        sure_subscription: 'Are you sure you want to reset purchase information?'
    },
    document: {
        title: 'Client download (tutorial)',
        // v2ray
        v2rayNG: {
            name: '📱 Android Client - v2rayNG', 
            step1: '① Please purchase first',
            step1_content1: 'Purchase',
            step2: '② Copy the node url address',
            step2_content1: 'After the purchase is completed, please click one-click purchase and copy the purchase link',
            step2_content2: 'Copy purchase link',
            step3: '③ Download and install Android client -- v2rayNG',
            step3_content1: 'Click to download',
            step4: '④ Enter Purchase group settings',
            step4_content1: '- Open V2rayNG and click on the upper left corner to expand more options',
            step4_content2: '- Click "Purchase group setting"',
            step5: '⑤ Configure purchase',
            step5_content1: '- After entering the purchase settings, click "+" in the upper right corner to enter the node settings page',
            step5_content2: '- remarks: fill in a custom name',
            step5_content3: '- Optional URL: Enter the node URL address pasted in step',
            step5_content4: 'Click "√" in the upper right corner to complete the configuration',
            step6: '⑥  Update purchase',
            step6_content1: '- Return to the main page and click ":" in the upper right corner ',
            step6_content2: '- Select "Update Purchase"',
            step6_content3: '- Node information will be displayed on the main page',
            step7: '⑦ Get started',
            step7_content1: '- Select any node',
            step7_content2: '- Click the gray mark "V" in the lower right corner of the homepage. When the gray mark turns green, the connection is successful and the Internet is opened.',
        },
        Clash_for_Windows: {
            name: '💻 Windows Client - Clash for Windows',
            step1: '① Please purchase first',
            step1_content1: 'Purchase',
            step2: '② Copy the node url address',
            step2_content1: 'After the purchase is completed, please click one-click purchase and copy the purchase link',
            step2_content2: 'Copy purchase link',
            step3: '③ Download and install the Windows client -- Clash for Windows',
            step3_content1: 'Click to download',
            step4: '④ Configure Clash for Windows',
            step4_content1: '- Open Clash for Windows, enter Profiles from the sidebar, enter the URL copied in step 2, and then click the Download button',
            step4_content2: '- Enter Proxies, select Rule at the top, and then select your favorite node in the Strategy Group below.',
            step4_content3: '- Then go back to General from the sidebar and check System Proxy below.',
        },
        Shadowrocket: {
            name: '🍎 IOS Client - Shadowrocket',
            step1: '① Please purchase first',
            step1_content1: 'Purchase',
            step2: '② Copy the node url address',
            step2_content1: 'After the purchase is completed, please click one-click purchase and copy the purchase link',
            step2_content2: 'Copy purchase link',
            step3: '③ Download and install iOS client -- Shadowrocket',
            step3_content1: 'Click to download',
            step4: '④ Configure purchase',
            step4_content1: '- Open the Shadowrocket homepage, Click the "+" in the upper right corner, click "Type" in the first line again, and select the Purchase link.',
            step4_content2: '- Enter Mute-Cs in "Remarks", then paste your purchase link below in "URL" and save it.',
            step4_content3: '- Then click Save in the upper right corner, and the server will be automatically updated.',
            step4_content4: '- Return to the home page, click to enter "Global Routing" and change it to Configuration.',
        },
        FoXray: {
            name: '🍎 IOS Client - FoXray',
            step1: '① Please purchase first',
            step1_content1: 'Purchase',
            step2: '② Copy the node url address',
            step2_content1: 'After the purchase is completed, please click one-click purchase and copy the purchase link',
            step2_content2: 'Copy purchase link',
            step3: '③ Download and install iOS client -- FoXray',
            step3_content1: 'Click to download',
            step4: '④ Configure purchase',
            step4_content1: '- Open the FoXray homepage and click "Purchases" at the bottom',
            step4_content2: '- On the "Purchases" page, click the "+" in the upper right corner',
            step4_content3: '- name: Enter a custom name',
            step4_content4: '- URL: Enter the purchase link copied in step 2',
            step4_content5: 'Click "Add" at the bottom to complete the configuration',
        },
        Official:{
            name:'📱 Official Android client',
            step1:'① Please purchase first',
            step1_content1:'Purchase',
            step2:'② Download and install the official Android client',
            step2_content1:'Click to download',
            step3:'③ Use of official clients',
            step3_content1:'After downloading and completing the installation comments client, open it and you will see the login interface of the client. Enter your Mute-Cs account and password to directly log in to the client. After logging in, click Connect to start using our service.',
        }
    },
    pannel: {
        used:'Used',
        total:'Total',
        announcement: 'Announcement',
        my_subscription: 'My purchase',
        expires_on: 'Expires on',
        expiration: 'days left until expiration',
        shortcut: 'Shortcut',
        view_tutorial: 'View tutorial',
        learn: 'Learn how to use Mute-Cs',
        quick_subscription: 'Quick purchase',
        quick_import: 'Quickly import nodes to the corresponding client for use',
        renew_subscription: 'Renew purchase',
        renew_your_current_subscription: 'Renew your current purchase',
        encounter_problems: 'Encounter problems',
        communicate: "If you encounter any problems, you can communicate with us through email: service{'@'}mute-cs.com",
        copy: 'Copy purchase link',
        qr: 'Scan the QR code to purchase',
        usage: 'If you don’t know how to use it, please check the usage tutorial.',
    },
    subscription: {
        choose: 'Please choose the package that suits you best',
        all: 'All',
        by_cycle :'By cycle',
        by_traffic:'By traffic',
        order: 'Order',
        payment_cycle: 'Payment cycle',
        monthly_payment: 'monthly payment',
        quarterly_payment: 'quarterly payment',
        annual_fee: 'annual fee',
        order_total: 'Order total',
        total: 'Total',
        place_an_order: 'Place an order',
        commodity_information: 'Commodity Information',
        product_name: 'Product Name',
        type: 'Type/Period',
        method: 'Payment method',
        checkout: 'Checkout',
        configure_subscription: 'Configure purchase',
        payment_currency: 'payment currency',
        order_number: 'order number',
        order_information: 'Ordering Information',
        creation_time: 'creation time',
        phone_number:'Phone number',
        area_code:'Area code',
        first_name:'First name',
        last_name:'Last name',
        email: 'E-mail',
        order_payment_failed:'Order payment failed',
        order_canceled:'Order canceled',
        hans_sucess:'The order has been paid and activated',
        view_tutorial:'View tutorial',
        order_timeout:'Order timeout',
        order_expired:'Order expired',
        cancel_payment:'Cancel payment',
        order_status_unknown:'Order status unknown',
        order_chargeback:'Order chargeback',
        order_in_process:'Order in process',
        order_has_been_refunded:'Order has been refunded',
        other_subscripe:"The package is expected to be effective on",
    },
    nodes: {
        name: 'Name',
        state: 'State',
        magnification: 'Magnification',
        label: 'Label',
        state_title: 'Node online status within five minutes',
        magnification_title: 'The traffic used will be multiplied by the multiplier for deduction'
    },
    login: {
        tip: 'Explore the world safer and more reliably',
        email: 'E-mail',
        password: 'password',
        verification_code: 'Verification code',
        login: 'login',
        register: 'Register',
        forget: 'Forget the password',
    },
    register: {
        username: 'Username',
        email_code: 'E-mail verification code',
        send: 'Send',
        agree: 'I have read and agree to the User License Agreement',
        register: "Register",
        return_login: 'Return to login'
    },
    prompt: {
        picture_code: 'Please fill in the picture verification code first',
        username_error: 'username error',
        email_err: 'Email format error',
        password_err: 'Password can not be blank',
        email_code_err: 'Email verification code cannot be empty',
        Registration_success: 'Registration success',
        Sent_successfully: 'Sent successfully',
        Mistake: 'Mistake',
        Success: 'Success',
        all_not_empty: 'User email, password, and picture verification code cannot be empty.',
        password_diff: 'The new password entered twice is different.',
        password_change_success: 'Password reset complete',
        reset_successful: 'Reset successful',
        reset_password:'Reset Password',
        enter_discount_code:'Enter discount code',
        verify:'Verify',
        invalid_discount_code:'Invalid discount code',
        cancel_success:'Cancel success',
        paying:'Paying',
        cancel_order:'You still have unfinished orders for this product and need to cancel them before purchasing. Are you sure you want to cancel your previous orders?',
        confirm_order_cancellation:'Confirm order cancellation',
        close_order:'Close order',
        no_order:'There is currently no order information available',
        no_currencies:'There is currently no payment currency information available',
        has_subscripe:'You already have an available package, and the newly purchased package will take effect after the available package expires. Confirm your purchase?',
        pass_rule:"Passwords must contain a combination of uppercase and lowercase letters and numbers, and special characters can be used",
        pass_rule_err:'Password format error',
    },
    docx: {
        title:'User License Agreement',
        tip_date:'Latest update date: August 1, 2023',
        tip1:'introduction',
        tip1_content1:'Welcome to Mute-Cs (hereinafter referred to as "this product")! The purpose of this User License Agreement (hereinafter referred to as the "Agreement") is to establish the relationship between you (hereinafter referred to as the "User" or "You") and GENTRY ELECTRIC CO., LIMITED (hereinafter referred to as the "Company"), and to clarify the conditions for using this product. Unless you accept all the terms of this agreement, you have no right to register, log in, or use the services covered by this agreement. Your registration, login, use, and other actions will be deemed as acceptance of this agreement, and you agree to be bound by the terms of this agreement. This agreement stipulates the rights and obligations of Mute-Cs and the User regarding the Services (hereinafter referred to as the "Services"). User "refers to individuals who register, log in, and use this service. Mute-Cs has the right to update the terms of the agreement. Once the updated terms of the agreement are published, they will replace the original terms of the agreement without further notice.',
        tip2:'Account registration',
        tip2_content1:'1. Users need to register one and only one "Mute-Cs" account before using this service. The "Mute-Cs" account should be registered using email binding. Users are requested to register the "Mute-Cs" account using an email that has not been bound to other "Mute-Cs" accounts or has not been banned by Mute-Cs according to this agreement. Mute-Cs reserves the right to make changes to the account registration and binding methods based on user needs or product needs without further notice.',
        tip2_content2:"2. If the registration applicant has a precedent of being banned by Mute-Cs, is suspected of false registration and misuse of someone else's name, registers more than one account, or uses a disposable temporary email address for registration, or other reasons that cannot be granted permission, Mute-Cs has the right to refuse to provide services to them.",
        tip2_content3:"3. Mute-Cs has noticed that registering and using Mute-Cs by citizens of certain countries (such as the People's Republic of China, the Islamic Republic of Iran, the Republic of Cuba, the Democratic Republic of Korea, etc.) will be considered a violation of the law. Mute-Cs does not recommend citizens of such countries to register or use our services, nor does it recommend citizens of any other country to register or purchase Mute-Cs services while residing in such countries. Please refer to Article 2 of the company statement for details.",
        tip3:'Account security',
        tip3_content1:'1.Once the user successfully registers and becomes a Mute-Cs user, they will receive a username and password, and have the right to use their own username and password to log in to Mute-Cs at any time.',
        tip3_content2:"2. Users are fully responsible for the security of their accounts and passwords, as well as for all activities and events conducted with their accounts.",
        tip3_content3:"3.Mute-Cs shall not disclose users' personal privacy and information without their permission.",
        tip3_content3_1:"1)If the user's password security is threatened due to password leakage or any other reason, they should promptly contact Mute-Cs customer service personnel, otherwise they will bear the corresponding losses.",
        tip4:'User Declaration and Warranty',
        tip4_content1:'1. Users must have full civil capacity and the ability to enter into transactions and fulfill their obligations.',
        tip4_content2:"2. Any services provided by Mute-Cs that users purchase to are only applicable to the user themselves. Users are not allowed to share their account, link, purchase address, or other information that results in multiple users sharing the service on any platform in any form.",
        tip4_content3:"3. Any content created, uploaded, copied, published, or disseminated by users through the use of Mute-Cs, including but not limited to account avatars, names, user instructions, and other registration information and authentication materials, as well as text, voice, images, videos, and related link pages, as well as other content generated by the use of the account or this service, It shall not violate the laws and regulations of the user's region/country or the Federative Republic of Brazil, including but not limited to the following principles: opposing the basic principles established by the constitution",
        tip4_content3_a:"a. Harming national security, leaking national secrets, subverting national power, and undermining national unity",
        tip4_content3_b:"b. Damage to national honor and interests",
        tip4_content3_c:"c. Inciting ethnic hatred, discrimination, and undermining ethnic unity",
        tip4_content3_d:"d. Disrupting national religious policies, promoting cults and feudal superstitions",
        tip4_content3_e:"e. Spreading rumors, disrupting social order, and disrupting social stability",
        tip4_content3_f:"f. Spreading obscenity, pornography, gambling, violence, murder, terror, or abetting crimes",
        tip4_content3_g:"g. Insulting or defaming others, infringing on their legitimate rights and interests",
        tip4_content3_h:"h. Containing other content prohibited by laws and administrative regulations",
        tip4_content4:'4. Users shall not use their "Mute-Cs" account or this service to create, upload, copy, publish, or disseminate content that interferes with normal operations, or infringes on the legitimate rights and interests of other users or third parties: content that contains any sexual or sexual implications',
        tip4_content4_a:"a. Containing insults, intimidation, and threats",
        tip4_content4_b:"b. Containing harassment, spam advertising, malicious information, and deceptive information",
        tip4_content4_c:"c. Involving the privacy, personal information or data of others",
        tip4_content4_d:"d. Infringement of legitimate rights such as reputation, portrait, intellectual property, and trade secrets of others",
        tip4_content4_e:"e. Contains information that interferes with the normal operation of this service and infringes on the legitimate rights and interests of other users or third parties.",
        tip5:"service content",
        tip5_content1:"1. The specific service content of Mute-Cs will be provided by Mute-Cs according to the actual situation,",
        tip5_content2:"2. Announcements and other messages to users can be sent through email or the contact information provided by the user.",
        tip6:"Privacy Policy",
        tip6_content1:"You agree that the company collects, uses, and processes your personal information in accordance with its privacy policy. Please read the privacy policy in the company's terms of use for detailed information.",
        tip7_content1:"Update and Support",
        tip7_content2:"The company may provide updates and upgrades to this product from time to time to provide new features, improve performance, and fix vulnerabilities. You agree to automatically receive these updates, and the company is not responsible for any issues caused by the updates.",
        tip8:"Disclaimers",
        tip8_content1:"1. This product is provided as is and without any express or implied warranties, including but not limited to warranties of merchantability, suitability for specific purposes, and non infringement.",
        tip8_content2:"2. Company 2 shall not be liable for any direct or indirect losses caused by the use of this product, including but not limited to data loss, profit loss, business interruption, etc.",
        tip9:"termination",
        tip9_content1:"The company reserves the right to terminate your usage license at any time if you violate any of the terms of this agreement. After termination, you will cease to use this product and delete all content and data related to this product.",
        tip10:"Applicable Law and Dispute Resolution",
        tip10_content1:"1. This agreement shall be governed by the laws of the Hong Kong Special Administrative Region. Any dispute should first be resolved through friendly consultation between both parties.",
        tip10_content2:"2. If consultation fails, the dispute will be submitted to the courts of the Hong Kong Special Administrative Region and resolved in accordance with their arbitration rules.",
        tip11:"Agreement Change",
        tip11_content1:"The company reserves the right to modify this agreement at any time. The updated agreement will take effect today. By continuing to use this product, you accept the revised agreement.",
    },
    state:{
        no_state:'No available nodes, if you are not purchased or have expired , please ',
        order:' purchase'
    }

}